export default __webpack_public_path__ + "static/media/wellness-score-main-image.b9e8ddd9.svg";